import get from 'lodash/get';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

type TGoBackParams = TParentLocation & {
  state: TCurrentParams;
};

type TUseParentPageReturn = {
  getGoBackParams: (fallbackUrl: string) => TGoBackParams;
  goForward: (url: string) => void;
};

export type TParentLocation = {
  pathname?: string;
  search?: string;
};

type TCurrentParams = {
  id?: string;
};

export const useParentPage = (): TUseParentPageReturn => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams<TCurrentParams>();

  return {
    getGoBackParams: (fallbackUrl: string): TGoBackParams => {
      const pathname: Maybe<string> = get(location.state, 'pathname', fallbackUrl);
      const search: Maybe<string> = get(location.state, 'search');

      return {
        pathname,
        search,
        state: {
          id,
        },
      };
    },
    goForward: (url: string) => navigate(`${url}${location.search}`),
  };
};

export const useRootPath = (idx?: Maybe<number>) => {
  const location = useLocation();

  const urootPath = location.pathname.split('/').filter(Boolean)[idx ?? 0];

  return urootPath;
};
